import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { deleteAllNodePositions } from '../../../app/api/generated/client';
import { queryKeys } from '../query-keys';

export function useDeleteNodePositions(mainPartnerUuid: string): UseMutationResult<void, AxiosError, void> {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async () => {
            await deleteAllNodePositions({ path: { mainPartnerUuid } });
        },
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.familyTree(mainPartnerUuid) }),
    });
}
